module.exports = __webpack_public_path__ + "improve-health.395c29e2872f025c09af.png";